var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
export var mapColorsToScheme = function (siteVars, mapper) {
    return _.mapValues(__assign({}, siteVars.emphasisColors, siteVars.naturalColors), typeof mapper === 'number' ? String(mapper) : mapper);
};
